import 'react-datepicker/dist/react-datepicker.css'
import styled from 'styled-components'

import H4 from '@/components/H4'
import { ItemHeader } from '@/components/Style/Common'
import type { SupportingDocument, DocumentBypassReason } from '@/types/Activity'
import { camelCaseToReadable } from '@/utils/helpers'

const SupportingDocuments = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 10px;
  align-items: center;
`

const SupportingDocumentContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  img {
    margin-right: 5px;
  }

  #document-proof {
    text-transform: capitalize;
  }
`

const Proof = styled.img`
  max-width: 100%;
  max-width: 125px;
  height: auto;
  border-radius: 10px;
  flex: 1;
  object-fit: contain;
`

const ApplicantReason = styled.p`
  margin-top: 4px;
`

interface Props {
  supportingDocuments: SupportingDocument[] | null
  incomeIndex: number
  handleImageClicked: Function
  documentBypassReason?: DocumentBypassReason | null
}

const SupportingDocumentsDetails: React.FC<Props> = ({
  supportingDocuments,
  incomeIndex,
  handleImageClicked,
  documentBypassReason,
}) => {
  const hasNoDocuments = !supportingDocuments || supportingDocuments.length === 0
  return (
    <div>
      <H4>Document Evidence</H4>
      {supportingDocuments && (
        <SupportingDocuments>
          {supportingDocuments.map(({ documentReference, thumbnail, type }, docIndex) => (
            <SupportingDocumentContainer
              key={docIndex}
              onClick={() => handleImageClicked(incomeIndex, docIndex)}
            >
              <Proof src={thumbnail ?? documentReference} alt={`A ${type} Document`} />
              <ItemHeader>
                Document Type{' '}
                <span id="document-proof">: {camelCaseToReadable(type)}</span>
              </ItemHeader>
            </SupportingDocumentContainer>
          ))}
        </SupportingDocuments>
      )}
      {hasNoDocuments && <p>No supporting documents have been supplied.</p>}
      {hasNoDocuments && documentBypassReason?.additionalInformation && (
        <ApplicantReason>
          Applicant reason provided: &ldquo;{documentBypassReason.additionalInformation}
          &rdquo;
        </ApplicantReason>
      )}
    </div>
  )
}

export default SupportingDocumentsDetails
